import React, { useState } from "react";
import { RCCButton,  RCCGrid,  RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import HeaderDashboard from "src/components/DashboardComponents/DefaultDashboardComponents/HeaderDashboard";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { AuditType } from "src/pages/Audits/Panel/interface";
import AppIcons from "src/components/AppIcons";
import { v4 } from "uuid";
import { ICardConfigs, MAX_HEIGHT_LISTS_DASHBOARD } from "../../../interface";
import { IDashboardAuditsData } from "../interface";
import Li from "./li";
import * as Styles from "../styles";
import { FilterButton, FilterButtonSelected } from "../styles";

const DashboardSummaryAuditsSector: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();

	const [filterList, setFilterList] = useState<AuditType | undefined>();
	const [dataCard, setDataCard] = useState<IDashboardAuditsData[]>([]); 
	const [totalItenGrouped, setTotalItenGrouped] = useState<{ external: number, internal: number }>({
		external: 0,
		internal: 0
	});

	const { loading } = useEffectFetchData<IDashboardAuditsData[]> (
		"DashboardAudits/SummarySector",
		{	type: filterList ?? "" },
		({ data }) => {
			if(!data || data.length <= 0){
				setDataCard([{
					count: 0,
					id: 0,
					inAudit: 0,
					finished: 0,
					opened: 0,
					title: ""
				}]);
				return;
			}
			if(!filterList){
				let totalExternal = 0;
				let totalInternal = 0;
				data.forEach((element: any) => {
					totalExternal += element.external;
					totalInternal += element.internal;
				});
				setTotalItenGrouped({
					external: totalExternal,
					internal: totalInternal
				});
			}
			setDataCard(data);
		},
		[filterList]
	);

	const filterAuditsOnClickBar = (quadrant: AuditType) => {
		let quadrantToUpdate: AuditType | undefined = quadrant;	
		if(filterList && filterList === quadrant)
			quadrantToUpdate = undefined;
		setFilterList(quadrantToUpdate);
	};

	return(
		<>
			<DefaultContainer>
				<HeaderDashboard 
					description={card?.daa002Descricao}
					title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo Auditorias por Setor")}
					hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
					isLoading={loading}
				>
					<RCCGrid container justifyContent="flex-end">
						<RCCTooltip
							text={`${totalItenGrouped.internal}	${totalItenGrouped.internal > 1 ? translate("Internas") : translate("Interna")}`}
							color="green"
						>
							<RCCButton 
								color="green" 
								styleInline={filterList && filterList !== AuditType.INTERNAL ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterAuditsOnClickBar(AuditType.INTERNAL); }}
							>
					 		{totalItenGrouped.internal}	{totalItenGrouped.internal > 1 ? translate("Internas") : translate("Interna")}
							</RCCButton>
						</RCCTooltip>
						<RCCTooltip
							text={`${totalItenGrouped.external}	${totalItenGrouped.external > 1 ? translate("Externas") : translate("Externa")}`}
						>
							<RCCButton 
								color="red" 
								styleInline={filterList && filterList !== AuditType.EXTERNAL ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterAuditsOnClickBar(AuditType.EXTERNAL); }}
							>
					 		{totalItenGrouped.external}	{totalItenGrouped.external > 1 ? translate("Externas") : translate("Externa")}
							</RCCButton>
						</RCCTooltip>
					</RCCGrid>
					<Link to={`/audit/panel/?type=${filterList ?? ""}`}>
						<RCCTooltip
							text={translate("Painel de Auditorias")}
							color="grey"
						>
							<RCCButton
								color="transparent"
							>
								<AppIcons 
									name="audits"
									size={14}
								/>
							</RCCButton>
						</RCCTooltip>
					</Link>
				</HeaderDashboard>
				<DefaultBody maxHeight={MAX_HEIGHT_LISTS_DASHBOARD}>

					{dataCard && dataCard.length > 0 && (
						<>
							<Styles.LiTitles>
								<div />
								<div><RCCTooltip text={translate("Abertas")} position="leftEnd" color="purple" >{translate("Abertas")} </RCCTooltip></div>
								<div><RCCTooltip text={translate("Em Auditoria")} position="leftEnd" color="blue" >{translate("Em Auditoria")} </RCCTooltip></div>
								<div><RCCTooltip text={translate("Concluídas")} position="leftEnd" color="green" >{translate("Concluídas")} </RCCTooltip></div>
								<div><RCCTooltip text={translate("Total")} position="leftEnd" color="grey" >{translate("Total")} </RCCTooltip></div>
							</Styles.LiTitles>		
								
							{dataCard && dataCard.length > 0 && dataCard.map((item) => (
								<Styles.LiPanelBodyContent  key={v4()}>
									<Li data={item} filter={filterList} />
								</Styles.LiPanelBodyContent>
							))} 
							
						</>
					)}
	
				</DefaultBody>
			</DefaultContainer>
		</>
	);
};

export default DashboardSummaryAuditsSector;
